import api from './api';

const notificationService = {
  // Legacy (kept for backward compat)
  getNotifications: (params = {}) =>
    api.get('/notifications.php', { params: { action: 'list', ...params } }).then(r => r.data),

  getUnreadCount: () =>
    api.get('/notifications.php', { params: { action: 'unread_count' } }).then(r => r.data),

  markRead: (id) =>
    api.post('/notifications.php?action=mark_read', { id }).then(r => r.data),

  markAllRead: () =>
    api.post('/notifications.php?action=mark_read', { all: true }).then(r => r.data),

  // Unified (notifications + messages merged)
  getUnifiedList: (params = {}) =>
    api.get('/notifications.php', { params: { action: 'unified_list', ...params } }).then(r => r.data),

  getUnifiedUnreadCount: () =>
    api.get('/notifications.php', { params: { action: 'unified_unread_count' } }).then(r => r.data),

  markUnifiedRead: (id) =>
    api.post('/notifications.php?action=unified_mark_read', { id }).then(r => r.data),

  markAllUnifiedRead: () =>
    api.post('/notifications.php?action=unified_mark_read', { all: true }).then(r => r.data),
};

export default notificationService;
